<template>
  <div>
    <button @click="onSubmitPayment" :class="buttonClass">
      {{ buttonLabel }}
    </button>
  </div>
</template>
<script>
import settings from "../../api/settings"
import plansApi from "../../api/plans"
import { mapGetters } from "vuex"
export default {
  props: [
    "selectedPlan",
    "isRecharge",
    "buttonLabel",
    "buttonClass",
    "formName",
    "formEmail",
    "isCash",
  ],
  data() {
    return {
      //DEV MODE ON

      description: "panel testing",
      directa_prod: settings.directa_prod,
      settings: settings,
      //amount: this.selectedPlan.price,

      /* name: "Juan Vargas",
      email: "juan_vargas10@hotmail.com", */
    }
  },
  methods: {
    onSubmitPayment() {
      console.log("click mi pa")
      if (!this.isRecharge) {
        plansApi
          .directaPaymentRequest(
            this.user.kProfile,
            this.selectedPlan._id,
            //discount it'll change=
            1,
            this.selectedPlan.price,
            "directa24",
            this.paymentData
          )
          .then(apiResponse => {
            console.log(apiResponse, "directa Response")
            const { redirect_url } = apiResponse

            setTimeout(() => {
              window.open(redirect_url, "_blank")
            }, 500)
          })
      } else {
        console.log(
          this.user.id,
          this.selectedPlan.promo_on_credits,
          this.selectedPlan.price,
          "Recargaaaaaa"
        )
        plansApi
          .directaRechargeRequest(
            this.user.id,
            this.selectedPlan.promo_on_credits,
            this.selectedPlan.price,
            "directa24",
            this.paymentData
          )
          .then(apiResponse => {
            console.log(apiResponse, "directa Response")
            const { redirect_url } = apiResponse

            setTimeout(() => {
              window.open(redirect_url, "_blank")
            }, 500)
          })
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    paymentData() {
      let price = this.selectedPlan.price
      price =
        price / 1000 <= 1 && this.settings.CURRENCY == "COP"
          ? (price = price * 1000)
          : price
      return {
        // invoice_id: "1000000001",
        amount: price,
        country: this.settings.COUNTRY,
        currency: this.settings.CURRENCY,
        payer: {
          id: this.user.kProfile,
          //document: "84932568207",
          //document_type: "CPF",
          //first_name: "Ricardo",
          // last_name: "Carlos",
          // phone: "+23385266942",
          // email: "juanCarlos@hotmail.com",
          // address: {
          //  street: "Calle 13",
          //  city: "bahia",
          //  state: "SP",
          //  zip_code: "12345-678",
          // },
        },
        back_url:
          this.directa_prod.redirectUrlBase + "/payments?message=DECLINED",
        success_url:
          this.directa_prod.redirectUrlBase + "/payments?message=APPROVED",
        error_url:
          this.directa_prod.redirectUrlBase + "/payments?message=DECLINED",
        notification_url: !this.isRecharge
          ? this.directa_prod.notifyUrl
          : this.directa_prod.notifyUrlRecharge,
        logo: this.directa_prod.url_logo,
        test: this.directa_prod.test,
        mobile: true,
        language: this.directa_prod.language,
      }
    },
    amount() {
      return this.selectedPlan.price
    },
    kProfileFull() {
      return this.user.profiles.find(pro => {
        return pro._id == this.user.kProfile
      })
    },
  },
}
</script>
